"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = void 0;
exports.clear = {
    path: "M15.8333 5.34167L14.6583 4.16667L9.99999 8.82501L5.34166 4.16667L4.16666 5.34167L8.82499 10L4.16666 14.6583L5.34166 15.8333L9.99999 11.175L14.6583 15.8333L15.8333 14.6583L11.175 10L15.8333 5.34167Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray1",
    activeColor: "tableBlack2"
};
